
const newModel = () => {
    return {
        thuchiNgansachId: null,
        chitieuThuchiNgansachId: null,
        tenChitieuThuchiNgansach: null,
        idKy: null,
        tenKy: null,
        luyKeThucHien: null,
        soVoiKeHoach: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null,

    }
}

const newFEModel = () => {
    return {
        thuchiNgansachId: null,
        chitieuThuchiNgansachId: null,
        idKy: null,
        luyKeThucHien: null,
        soVoiKeHoach: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null,
    }
}

const fromJson = (item) => {
    return {
        thuchiNgansachId: item.thuchiNgansachId,
        chitieuThuchiNgansachId: item.chitieuThuchiNgansachId,
        tenChitieuThuchiNgansach: item.tenChitieuThuchiNgansach,        
        idKy: item.idKy,
        tenKy: item.tenKy,
        luyKeThucHien: item.luyKeThucHien,
        soVoiKeHoach: item.soVoiKeHoach,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted: item.userDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thuchiNgansachId: item.thuchiNgansachId,
        chitieuThuchiNgansachId: item.chitieuThuchiNgansachId,    
        idKy: item.idKy,
        luyKeThucHien: item.luyKeThucHien,
        soVoiKeHoach: item.soVoiKeHoach,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted: item.userDeleted,
    }
}

const errors = () => {
    return {
        thuchiNgansachId: null,
        chitieuThuchiNgansachId: null,
        idKy: null,
        luyKeThucHien: null,
        soVoiKeHoach: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
    }
}

export const thuchiNgansachModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


